import { motion } from "framer-motion";
import { Sparkles, Calendar } from "lucide-react";
import { useContext } from "react";
import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from '../../translate/i18n';
export function WelcomeCard() {
  const { user } = useContext(AuthContext) as any;
  const userName = user?.name?.split(" ")[0] || "Usuário";

  // Get greeting based on time of day
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return i18n.t("v2.welcome.goodMorning");
    if (hour < 18) return i18n.t("v2.welcome.goodAfternoon");
    return i18n.t("v2.welcome.goodEvening");
  };
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="relative overflow-hidden rounded-[14px] bg-gradient-to-r from-[#1E40AF] to-[#2563EB] p-6 shadow-lg"
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <svg className="h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none">
          <defs>
            <pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse">
              <circle cx="1" cy="1" r="1" fill="white" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      <div className="relative flex items-center justify-between">
        <div>
          <div className="flex items-center gap-2 mb-2">
            <Sparkles className="h-5 w-5 text-yellow-300" />
            <span className="text-sm font-medium text-blue-100">
              {getGreeting()}
            </span>
          </div>
          <h2 className="text-2xl font-bold text-white">
            {i18n.t("v2.welcome.welcomeBack", { name: userName })}
          </h2>
          <div className="mt-3 flex items-center gap-2 text-blue-100">
            <Calendar className="h-4 w-4" />
            <span className="text-sm">{i18n.t("v2.welcome.activeUntil", { date: "31/01/2026" })}</span>
          </div>
        </div>

        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring" }}
          className="hidden md:flex h-20 w-20 items-center justify-center rounded-full bg-white/10 backdrop-blur-sm"
        >
          <span className="text-4xl">👋</span>
        </motion.div>
      </div>
    </motion.div>
  );
}